import { ErrorMessage, Label, PasswordInput, TextInput } from 'components/Form'
import Spinner from 'components/Spinner'
import notification from 'helpers/notification'
import { useValidate } from 'hooks/useValidate'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import services from 'services/index'
import { authorization } from 'store/user'
import { loginSchema } from '../validations'
const LoginWithPassword = () => {
	const dispatch = useDispatch()
	const [loading, setLoading] = useState(false)
	const { validate, memoizedErrors, clearErrors } = useValidate(loginSchema)
	const [auth, setAuth] = useState({
		password: '',
		username: '',
	})
	const { username, password } = auth
	const login = e => {
		e.preventDefault()
		const options = {
			data: auth,
			onSuccess: data => {
				const options = {
					data,
					onEnd: () => setLoading(false),
					onStart: () => setLoading(true),
					onError: () =>
						notification('Неверный логин или пароль', { type: 'error' }),
					onSuccess: response => {
						const data = response?.data
						const status = response?.status
						const token = response?.data?.access

						if (status === 200 && data) {
							localStorage.setItem('token', token)
							dispatch(authorization({ user: data, STATUS: 'SUCCESS' }))
						} else {
							notification('Неверный логин или пароль', {
								type: 'error',
							})
						}
					},
				}
				services.users.login(options)
			},
		}
		validate(options)
	}
	return (
		<form onSubmit={login} className='flex flex-col gap-6'>
			<div className='login'>
				<Label>Login</Label>
				<TextInput
					isDisabled={loading}
					isError={!!memoizedErrors?.username}
					onFocus={clearErrors}
					placeholder={'Loginni kiriting'}
					value={username}
					onChange={username => {
						clearErrors()
						setAuth({ ...auth, username })
					}}
				/>
				<ErrorMessage message={memoizedErrors?.username} />
			</div>
			<div className='password'>
				<Label>Parol</Label>
				<PasswordInput
					isDisabled={loading}
					isError={!!memoizedErrors?.password}
					onFocus={clearErrors}
					placeholder={'Parolni kiriting'}
					value={password}
					onChange={password => {
						clearErrors()
						setAuth({ ...auth, password })
					}}
				/>
				<ErrorMessage message={memoizedErrors?.password} />
			</div>
			{loading ? (
				<div className='flex items-center h-[48px] justify-center w-full'>
					<Spinner />
				</div>
			) : (
				<button type='submit' className='success-btn mt-4'>
					Kirish
				</button>
			)}
		</form>
	)
}
export default LoginWithPassword
